import { FilePenLine } from "lucide-react";
import { useRouter } from "@/lib/nav";
import { useTransition } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { settleRedirect } from "@/lib/redirect-error";
import { createContractFromQuote } from "@/api/actions/contract";

// 수주 견적에서 계약 초안을 만든다 — 새로 만들었으면 편집으로, 이미 있었으면 상세로 보낸다.
const CreateContractButton = ({ quoteId }: { quoteId: string }) => {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  const create = () =>
    startTransition(async () => {
      try {
        const result = await createContractFromQuote(quoteId);
        if (!result.ok) {
          toast.error(result.message);
          return;
        }
        router.push(
          result.created ? `/app/contracts/${result.contract_id}/edit` : `/app/contracts/${result.contract_id}`
        );
      } catch (error) {
        if (settleRedirect(error)) return;
        toast.error("계약서를 만들지 못했습니다");
      }
    });

  return (
    <Button disabled={pending} onClick={create} size="sm" type="button" variant="primary">
      <FilePenLine />
      계약서 만들기
    </Button>
  );
};

export default CreateContractButton;
